import 'Plugins/jquery-ui';
import Cookies from 'js-cookie';

const FORM_COOKIE_NAME = 'obv2-download-contact-form-shown';
const FORM_COOKIE_EXPIRES_IN_DAYS = 30;

/**
 * Initializing the download contact form.
 */
export default function initDownloadContact()
{
  // if cookie is set, we're done
  if (Cookies.get(FORM_COOKIE_NAME)) {
    return;
  }
  // give firefox (in particular) the chance to update the DOM
  setTimeout(function()
  {
    // else, add form trigger to every download link
    $('.download-usx, .download-usfm, .download-rtf, .download-pdf, .slide li a').
    on('click', function()
    {
      // check again, in case the form was just shown
      if (Cookies.get(FORM_COOKIE_NAME)) {
        return;
      }

      // give firefox (in particular) the chance to update the DOM
      setTimeout(function()
      {
        // create & show dialog
        const newDialog = $(
          '<div class="ui-dialog"><iframe height="600" width="550" src="/download-contact-form" class="download-contact-form-iframe"><div></div></iframe></div>').
        dialog({
          minWidth: 600,
          minHeight: 650,
          closeText: '\u2715',
          closeOnEscape: true,
          modal: true,
          show: true,
        });

        // give firefox (in particular) the chance to update the DOM
        setTimeout(function()
        {
          // adjust as soon as the iframe is done loading
          $('.download-contact-form-iframe').on('load', function()
          {
            // we're only supposed to see the form once, period
            Cookies.set(FORM_COOKIE_NAME, true,
              {expires: FORM_COOKIE_EXPIRES_IN_DAYS});

            // ensure all text input fields have borders
            // (may not be necessary after an update/style change)
            $(this).contents().
            find('input[type=\'text\']').addClass('ui-dialog-input-fix');

            // ensure the first input field is selected
            $(this).contents().
            find('input:first').
            trigger('focus').
            trigger('select');

            // re-center, in case all the DOM changes obscured
            // part of the form
            $(newDialog).
            dialog('option', 'position',
              {my: 'center', at: 'center', of: window});
          });

          // force reload, since firefox doesn't automatically load dynamic iframes
          $('.download-contact-form-iframe').
          attr('src', '/download-contact-form');
        }, 0);
      }, 0);
    });
  }, 0);
}

